































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class Tutorial extends Vue {
  @Prop({ required: true })
  showModal!: boolean;

  @Prop({ required: true })
  language!: string;

  // eslint-disable-next-line global-require, import/no-dynamic-require
  text = require(`@/text_${this.language}.json`);
}
